module.exports = __webpack_public_path__ + "media/images/color_admin_v3/product/product-preview-sm-beff5e619e81a0112be66f643e1c9587.jpg";